/** A repo→project binding as returned by the API. */
export interface ScmRepoBinding {
  id: string
  provider: string
  repositoryFullName: string
  projectId: string
  installationId: string
  branchFormat: string | null
  baseBranch: string | null
  linkbacksEnabled: boolean
}

/** A connected GitHub App installation (org/account) for the workspace. */
export interface ScmInstallation {
  installationId: string
  provider: string
  accountLogin: string | null
  isActive: boolean
}

/** A repository accessible to an installation (picker item). */
export interface ScmRepository {
  fullName: string
  private: boolean
}

/** A repo's branch names plus its default branch (base-branch picker). */
export interface ScmBranches {
  branches: Array<string>
  defaultBranch: string | null
}

/** A GitHub-login → Moly-member mapping for the workspace (PR author attribution). */
export interface ScmIdentity {
  login: string
  userId: string
  name: string
}

export interface StartConnectRequest {
  /** 'workspace' (default) | 'personal' */
  purpose?: 'workspace' | 'personal'
  /** Relative app path to land back on after the handshake. */
  returnPath?: string
}

export interface CreateBindingRequest {
  repositoryFullName: string
  projectId: string
  installationId: string
  branchFormat?: string
  baseBranch?: string
  linkbacksEnabled?: boolean
}

/** Fallback base branch shown when a binding has none set (matches backend default). */
export const DEFAULT_BASE_BRANCH = 'develop'

/** Branch-format presets offered in the settings dropdown (Linear-style). */
export const BRANCH_FORMAT_PRESETS = [
  'moly/{identifier}-{title}',
  '{username}/{identifier}-{title}',
  '{identifier}-{title}',
  'super-agent/{title}-{id}',
] as const

export const DEFAULT_BRANCH_FORMAT = 'moly/{identifier}-{title}'
